import { render, staticRenderFns } from "./chat-bot-footer-btn.vue?vue&type=template&id=cea48b10&scoped=true"
import script from "./chat-bot-footer-btn.vue?vue&type=script&lang=js"
export * from "./chat-bot-footer-btn.vue?vue&type=script&lang=js"
import style0 from "./chat-bot-footer-btn.vue?vue&type=style&index=0&id=cea48b10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea48b10",
  null
  
)

export default component.exports